<template>
    <b-card title="">
        <h3 class="text-primary font-weight-bold mb-2">
            ค้นหา กรุณาระบุข้อมูลค้นหาอย่างน้อย 1 ช่อง</h3>
        <b-row>
            <b-col md="6">
                <h5 class="h4 font-weight-bold">AL Code <span class="text-danger"></span></h5>
                <b-form-group>
                    <b-form-input id="IdCode" ref="IdCodeInput" v-model="formUser.IdCode"
                        :class="{ 'is-invalid': showError && !formUser.IdCode }" placeholder="AL Code" />
                    <b-form-invalid-feedback v-if="showError && !formUser.IdCode">
                        กรุณากรอก AL Code
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col md="6"></b-col>
            <b-col md="6">
                <h5 class="h4 font-weight-bold">เลือกวันที่ลงทะเบียน <span class="text-danger"></span></h5>
                <b-form-group>
                    <flat-pickr ref="dateInput" v-model="startDate" class="form-control" :config="DateConfig"
                        :class="{ 'is-invalid': showError && !startDate }" />
                    <b-form-invalid-feedback v-if="showError && !startDate">
                        กรุณาเลือกวันที่
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <br>
                <b-button variant="primary" type="submit" @click.prevent="getDataTable" :disabled="isLoading">
                    <template v-if="isLoading">
                        <b-spinner small type="grow" class="mr-1" />
                        กำลังค้นหา...
                    </template>
                    <template v-else>
                        ค้นหา
                    </template>
                </b-button>
                <!-- <b-button variant="primary" @click.prevent="getDataTable"> ค้นหา </b-button> -->
            </b-col>

        </b-row>
        <b-col md="6">

        </b-col>
        <b-col md="6">
            <br />
            <h3 class="text-primary font-weight-bold mb-2">
                ข้อมูลแรงงานต่างด้าว
            </h3>
        </b-col>
        <b-row>

            <b-col md="6" sm="4" class="my-1">
                <b-form-group class="mb-0">
                    <label class="h5 d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
                    <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
                </b-form-group>
            </b-col>
            <b-col md="6" class="my-1">
                <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm"
                    label-for="filterInput" class="h5 mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">
                                ยกเลิก
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <b-col cols="12">
            <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
                :filter-included-fields="filterOn" @filtered="onFiltered">
                <!-- 👇 CUSTOM ACTION COLUMN -->
                <template #cell(action)="props">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                        </template>
                        <b-dropdown-item @click="editItem(props.item)">
                            <feather-icon icon="Edit2Icon" class="mr-50" />
                            <span>แก้ไข</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="confirmText(props.item)">
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>ลบ</span>
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
        </b-col>
        <!-- Pagination -->
        <b-card v-show="true" class="p-0 mb-1" no-body>
            <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
                <div>
                    Showing {{ (currentPage - 1) * perPage + 1 }} to
                    {{ Math.min(currentPage * perPage, totalRows) }}
                    of {{ totalRows }} entries
                </div>
                <!-- {{currentPage}} -->
                <div class="bd-highlight">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                        @input="handlePageChange" class="mb-0" first-text="First" prev-text="Prev" next-text="Next"
                        last-text="Last" align="left" hide-goto-end-buttons />
                </div>
            </b-nav>
        </b-card>

        <b-modal id="edit-user-modal" title="แก้ไขข้อมูลแรงงานต่างด้าว" v-model="showEditModal" @ok="saveUserEdit"
            ok-title="บันทึก" cancel-title="ยกเลิก">
            <b-form-group label="อนุญาติเข้าออก" label-for="status">
                <b-form-select v-model="editUser.status" id="status" :options="prefixOptionsstatus" required />

            </b-form-group>
            <b-form-group label="cardSerialNumber" label-for="cardSerialNumber">
                <b-form-input v-model="editUser.cardSerialNumber" id="cardSerialNumber" />
            </b-form-group>

            <b-form-group label="คำนำหน้า" label-for="prefix">
                <b-form-select v-model="editUser.prefix" id="prefix" :options="prefixOptions" required />
            </b-form-group>

            <b-form-group label="ชื่อ" label-for="firstname">
                <b-form-input v-model="editUser.firstname" id="firstname" />
            </b-form-group>

            <b-form-group label="นามสกุล" label-for="lastname">
                <b-form-input v-model="editUser.lastname" id="lastname" />
            </b-form-group>


            <b-form-group label="เพศ" label-for="gender">
                <b-form-select v-model="editUser.gender" id="gender" :options="genderOptions" required />
            </b-form-group>

            <b-form-group label="สัญชาติ" label-for="nationality">
                <b-form-select v-model="editUser.nationality" id="nationality" :options="nationalityOptions" required />
            </b-form-group>

            <b-form-group label="รูปโปรไฟล์" label-for="profileImage">
                <b-form-file id="profileImage" v-model="editUser.profileImage" accept="image/*" browse-text="เลือกไฟล์"
                    placeholder="ยังไม่ได้เลือกไฟล์" @input="previewProfileImage" />
            </b-form-group>

            <div v-if="profilePreview" class="text-center mt-2">
                <img :src="profilePreview" alt="Preview" style="max-width: 150px; border-radius: 10px;">
            </div>
            <!-- <b-form-group label="เพศ" label-for="gender">
                <b-form-input v-model="editUser.gender" id="gender" />
            </b-form-group>
            <b-form-group label="สัญชาติ" label-for="nationality">
                <b-form-input v-model="editUser.nationality" id="nationality" />
            </b-form-group> -->
            <!-- 
      <b-form-group label="เบอร์โทรศัพท์" label-for="phone">
        <b-form-input v-model="editUser.phone" id="phone" />
      </b-form-group>

      <b-form-group label="อีเมล" label-for="email">
        <b-form-input v-model="editUser.email" id="email" type="email" />
      </b-form-group> -->

            <!-- เพิ่ม fields อื่นตามต้องการ เช่น IdCode, cardType ฯลฯ -->
        </b-modal>
        <div class="demo-inline-spacing">
            <!-- <div>
        <h5>Confirm Button Text</h5>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          @click="confirmText"
        >
          Confirm Text
        </b-button>
      </div> -->
            <!-- <div>
      <h5>Confirm Button Text</h5>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        @click="confirmButtonColor"
      >
        Confirm Button Color
      </b-button>
    </div> -->
        </div>
    </b-card>
</template>

<script>
import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
} from "bootstrap-vue";
import { BCard, BCardText } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
    components: {
        BTable,
        BAvatar,
        BBadge,
        BRow,
        BCard,
        BCardText,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
        flatPickr
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            perPage: 100,
            pageOptions: [25, 50, 100],
            totalRows: 1,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            sortDirection: "asc",
            filter: null,
            filterOn: [],
            infoModal: {
                id: "info-modal",
                title: "",
                content: "",
            },
            fields: [
                { key: "no", label: "ลำดับที่" },
                { key: "username", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
                { key: "cardSerialNumber", label: "cardSerialNumber" },
                { key: "prefix", label: "คำนำหน้า" },
                { key: "firstname", label: "ชื่อ" },
                { key: "lastname", label: "นามสกุล" },
                { key: "gender", label: "เพศ" },
                { key: "createdAtFormatted", label: "วันที่ลงทะเบียน" },
                { key: "status", label: "อนุญาติใช้งาน" },
                { key: "action", label: "แก้ไข/ลบ" }, // ✅ เพิ่มตรงนี้
            ],
            items: [],
            selected: null,
            options: [
                { value: null, text: "-- เลือกสิทธิ์ --" },
                { value: "admin", text: "admin" },
                { value: "staff", text: "staff" },
            ],
            formUser: {
                username: "",
                password: "",
                passwordFieldType: "password",
                firstname: "",
                lastname: "",
                IdCode: ''
            },
            prefixOptionsstatus: [
                { value: 'true', text: 'true' },
                { value: 'false', text: 'false' },
            ],
            prefixOptions: [
                { value: '', text: '--- เลือกคำนำหน้า ---' },
                { value: 'MR.', text: 'MR.' },
                { value: 'MRS.', text: 'MRS' },
                { value: 'MISS', text: 'MISS' },
                { value: 'MS.', text: 'MS.' }, // ✅ เพิ่ม MS.
            ],
            showEditModal: false,
            editUser: {
                userId: null,
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                gender: '',
                nationality: '',
                IdCode: '',
                prefix: '',
                cardSerialNumber: '',
                status: '',
                profileImage: null

                // ...เพิ่มฟิลด์อื่นตาม backend
            },
            profilePreview: null,
            genderOptions: [
                { value: '', text: '--- เลือกเพศ ---' },
                { value: 'M', text: 'Male' },
                { value: 'F', text: 'Female' },
            ],
            nationalityOptions: [
                { value: '', text: '--- เลือกสัญชาติ ---' },
                { value: 'LAOS', text: 'LAOS' },
                { value: 'CAMBODIA', text: 'CAMBODIA' },
                { value: 'MYANMAR', text: 'MYANMAR' },
            ],
            outDateConfig: {
                dateFormat: "d-m-Y",
                // onChange: this.handleOutDateChange.bind(this),
            },
            DateConfig: {
                dateFormat: "Y-m-d", // format ที่ใช้ส่งจริง
                altInput: true,
                altFormat: "d-m-Y",  // format ที่แสดงผล
                allowInput: true,
            },
            startDate: null,
            endDate: new Date(),
            showError: false,
            isLoading: false,

        };
    },
    computed: {
        sortOptions() {
            // Create an options list from our fields
            return this.fields
                .filter((f) => f.sortable)
                .map((f) => ({ text: f.label, value: f.key }));
        },
    },
    created() {
        //  this.getDataTable();
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;
    },
    methods: {
        validate() {
            if ((!this.formUser.IdCode || this.formUser.IdCode.trim() === "")
                && (!this.startDate || this.startDate === null)) {
                this.showError = true;
                return false;
            }

            this.showError = false;
            return true;
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`;
            this.infoModal.content = JSON.stringify(item, null, 2);
            this.$root.$emit("bv::show::modal", this.infoModal.id, button);
        },
        resetInfoModal() {
            this.infoModal.title = "";
            this.infoModal.content = "";
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        editItem(item) {
            this.profilePreview = null;
            this.editUser = { ...item }; // clone item
            console.log("Edit:", this.editUser.image[0]);
            this.showEditModal = true;
            // เพิ่ม logic แก้ไข
            if (this.editUser.image == undefined || this.editUser.image.length == 0) return;
            this.getImage();
        },
        async getImage() {
            try {
                const res = await axios.get(
                    `${API}files/image/${this.editUser.image[0]}`,
                    {
                        responseType: "arraybuffer", // สำคัญ!
                        headers: {
                            Authorization: await store.dispatch("getAuthorization"), // ใช้ refreshToken จาก JWT
                        }
                    }
                );
                console.log("res.data", res.data);

                // ดึง MIME Type จาก header ถ้าไม่มีใช้ jpeg เป็นค่า default
                const mimeType = res.headers["content-type"] || "image/jpeg";

                const blob = new Blob([res.data], { type: mimeType });
                this.profilePreview = URL.createObjectURL(blob);

                console.log("โหลดรูปสำเร็จ");
            } catch (err) {
                console.error("โหลดรูปไม่ได้", err);
            }
        },
        previewProfileImage(event) {
            if (!this.editUser.profileImage) {
                this.profilePreview = null;
                return;
            }

            const file = this.editUser.profileImage;
            this.profilePreview = URL.createObjectURL(file);
        },
        async saveUserEdit() {
            const jwt = JSON.parse(localStorage.getItem("company_jwt"));
            console.log(this.editUser.prefix);
            const _data = new FormData();
            //   _data.append("IdCode", this.editUser.IdCode);
            _data.append("prefix", this.editUser.prefix);
            _data.append("firstname", this.editUser.firstname);
            _data.append("lastname", this.editUser.lastname);
            _data.append("gender", this.editUser.gender);
            _data.append("nationality", this.editUser.nationality);
            _data.append("cardSerialNumber", this.editUser.cardSerialNumber);
            _data.append("status", this.editUser.status);
            if (this.editUser.profileImage != undefined && this.editUser.profileImage != null) {
                _data.append("image", this.editUser.profileImage ? this.editUser.profileImage : '');
            }
            //   console.log("image", this.editUser.profileImage);
            //   return;
            // console.log("editUser", this.editUser.lastname);
            try {
                const res = await axios.put(`${API}updateUserDetails/${this.editUser.userId}`, _data,
                    {
                        headers: {
                            Authorization: await store.dispatch("getAuthorization"), // ใช้ refreshToken จาก JWT
                        },
                    }
                );

                this.$bvToast.toast("บันทึกสำเร็จ", {
                    title: "สำเร็จ",
                    variant: "success",
                    solid: true,
                });
                this.showEditModal = false;
                await this.getDataTable(); // โหลดใหม่
            } catch (err) {
                console.error("❌ บันทึกไม่สำเร็จ:", err);
                this.$bvToast.toast("เกิดข้อผิดพลาดในการบันทึก", {
                    title: "ผิดพลาด",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        deleteItem(item) {
            console.log("Delete:", item);
            confirmText();
            // เพิ่ม logic ลบ
        },
        confirmText(item) {
            console.log(item);

            this.$swal({
                title: "ลบข้อมูล?",
                text: "คุณต้องการจะลบข้อมูล ใช่หรือไม่!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "ลบ",
                cancelButtonText: "ยกเลิก",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then(async (result) => {
                if (result.value) {
                    const refreshToken = localStorage.getItem("refresh_token");
                    await axios
                        .delete(`${API}deleteUserAccount`, {
                            data: {
                                userId: item.userId,
                            },
                            headers: {
                                Authorization: refreshToken, //await store.dispatch("getAuthorization"),
                            },
                        })
                        .then(async (el) => {
                            console.log(el.data.message);
                            if (el.data.message == "Delete Account Complete.") {
                                this.$swal({
                                    icon: "success",
                                    title: "ลบข้อมูล!",
                                    text: "ลบข้อมูลสำเร็จ",
                                    showCancelButton: false,
                                    showConfirmButton: true,
                                    timer: 1500,
                                    customClass: {
                                        confirmButton: "btn btn-success",
                                    },
                                });
                            }
                            this.getDataTable();
                        })
                        .catch((err) => {
                            if (err.response) {
                                console.error("❌ API Error:", err.response.status);
                                console.error("Response:", err.response.data);
                            } else {
                                console.error("❌ Error:", err.message);
                            }
                        });

                    return;
                }
            });
        },

        async getDataTable() {
            console.log('vvvvvvvvvvv')
            this.isLoading = true;
            if (!this.validate()) {
                this.isLoading = false;
                return;
            }
            try {
                const jwt = JSON.parse(localStorage.getItem("company_jwt"));

                console.log(jwt)

                const formatDate = (dateObj) => {
                    if (typeof dateObj === 'string') {
                        dateObj = new Date(dateObj);
                    }
                    if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";
                    const day = String(dateObj.getDate()).padStart(2, "0");
                    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                    const year = String(dateObj.getFullYear());
                    return `${day}-${month}-${year}`;
                };

                console.log(this.startDate)
                console.log(this.formUser.IdCode)


                // const startStr = formatDate(new Date(this.startDate));
                // const [dayExit, monthExit, yearExit] = startStr.split("-");
                // let params = {
                //     companyId: jwt.companyId,
                //     userId: jwt.userId,
                //     _page: this.currentPage,
                //     _limit: this.perPage,
                //     _sort: "-1",
                //     role: 'user',
                //     createdAt: `${yearExit}${monthExit}${dayExit}`
                // };

                const params = {
                    companyId: jwt.companyId,
                    userId: jwt.userId,
                    _page: this.currentPage,
                    _limit: this.perPage,
                    _sort: "-1",
                    role: 'user',
                };

                if (this.startDate != null && this.startDate != '') {
                    const startStr = formatDate(new Date(this.startDate));
                    const [dayExit, monthExit, yearExit] = startStr.split("-");
                    params['createdAt'] = `${yearExit}${monthExit}${dayExit}`;
                }

                if (this.formUser.IdCode && this.formUser.IdCode !== '') {
                    params['IdCode'] = this.formUser.IdCode; // ✅ ใช้ค่า IdCode ที่กรอกจริง
                }

                console.log(params);


                const res = await axios.get(`${API}allUserFromCompany`, {
                    params,
                    headers: {
                        Authorization: await store.dispatch("getAuthorization"),
                    },
                });
                console.log("✅ Response:", JSON.stringify(res.data));
                const results = await Promise.all(
                    res.data.message[0].results.map(async (item, index) => {
                        var sp = item.createdAt.split('T')
                        console.log(sp)
                        var createdAtFormatted_ = sp[0].split('-')
                        return {
                            ...item,
                            no: index + 1,
                            createdAtFormatted: createdAtFormatted_[2] + '/' + createdAtFormatted_[1] + '/' + createdAtFormatted_[0],
                        }
                    })
                );


                console.log("รวมทั้งหมด", results);

                this.items = results
                this.totalRows = res.data.message[0].total
            } catch (err) {
                 console.log(err.response.data);
                console.log(JSON.stringify(err.response.data));
                console.error("❌ Error:", err.response?.data || err.message);
            } finally {
                this.isBusy = false;
                this.isLoading = false;
            }

            return;

        },

        async handlePageChange(page) {
            console.log(page);
            this.currentPage = page;
            this.items = [];

            await this.getDataTable();
        },
        async handleItemsPerPageChange() {
            this.items = [];
            this.currentPage = 1;
            await this.getDataTable();
        },
    },
};
</script>